import React from 'react';

export default props => (
  <a className="be-link be-link--theme" {...props}>
    {props.children}
  </a>
);
